import { isEmptyValue, isString } from "utils/utils"
import PropTypes                  from 'prop-types';
import {first, filter}            from "lodash";
import { Option } from '../types/option';

export function getColumns(options: Option[]): string[] {
  if (options.length === 0) return []
  return Object.keys(options[0].tuple!)
}

export function selectOptionByLabel(options: Option[], label: string) {
  return first(filter(options, option => option.label === label))
}

export const isEqualOption = (option1: Option, option2: Option) => {
  return isEmptyValue(option1) && isEmptyValue(option2) ||
    (!isEmptyValue(option1) && !isEmptyValue(option2) && option1.value === option2.value)
}

export function selectOption(options: Option[], value: string) {
  return first(filter(options, option => option.value === value))
}

// we cannot store 'undefined' or 'null' with formik. We store value "", i.e., the empty string.
export const toFormikOptionValue = (option: Option) =>
  option === undefined || option === null ? "" : option.value

// material does not allow value 'undefined' for 'controlled' components, so that needs to be converted to 'null'
export const getMuiOption = (options: Option[], value: string) => {
  return value === null || value === undefined ? null : selectOption(options, value) || null
}

export const isSelectedValue = (value: String, selectedOptions: Option[]) =>
  selectedOptions.some(selected => selected.value == value)
export const isSelectedOption = (option: Option, selectedOptions: Option[]) =>
  selectedOptions.some(selected => selected.value == option.value)

export const filterSelectedOptions = (options: Option[], selectedOptions: Option[]) =>
  Array.isArray(selectedOptions) ? options.filter(option => !isSelectedOption(option, selectedOptions)) : options

export const optionsConstraint = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
}

export const filterDuplicateOptions = (options: Option[]) => {
  if (!isEmptyValue(options) && Array.isArray(options) && options.length > 1) {
    const lastOption = options[options.length-1]
    if (options.filter(option => option.value === lastOption?.value).length > 1)
      return options.filter(option => option.value !== lastOption?.value)
  }

  return options
}

export const toRegex = (expression: string) => {
  const regexExpression = expression
    .replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
    .replace(/\\\s+/g, '.*')

  return new RegExp(regexExpression, "i")
}

export function filterTableOptions(options: Option[], filter: string) {
  const regex = toRegex(filter)
  return options.filter(option => {
    if (option.tuple !== undefined) return Object.values(option.tuple).find(value => regex.test(value)) !== undefined
    else return regex.test(option.label)
  })
}

export const filterOptionsByLabelWithExpression = (options: Option[], expression: string) => {
  if (isString(expression) && expression?.length > 0) {
    const regex = toRegex(expression)
    return options.filter(option => typeof option.label === 'string' ? regex.test(option.label) : false)
  } else return options
}

export const filterOptions = (options: Option[], selected: Option[], expression: string) =>
  filterOptionsByLabelWithExpression(filterSelectedOptions(options, selected), expression)

export function isOption(obj: any) {
  return obj ? obj.hasOwnProperty("value") && obj.hasOwnProperty("label") : false
}

export const toOption = (value: any) => !value ? null : isOption(value) ? value : ({value: value, label: value})

export function createRandomOptions(count: number, pageOffset: number ) {
  function random(length: number) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i += 1) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    return result;
  }
  const offset = pageOffset ? pageOffset : 0
  return Array.from(new Array(count)).map((value,index) => ({label: (offset + index).toString() + ' ' + random(Math.ceil(Math.random() * 30)), value: offset + index}))
}

